import userNotificationApi from "api/services/user-notifications";
import userNotificationCaApi from "api/services/user-notifications-ca";
import logError from "utils/logError";

const getUserNotifications = async (
  take = 25,
  page = 1,
  countryCode: string,
) => {
  const api =
    countryCode === "CA" ? userNotificationCaApi : userNotificationApi;
  try {
    const { data } = await api(`/v2/user/notifications`, {
      params: {
        skip: (page - 1) * take,
        take: take,
      },
    });

    return data;
  } catch (error) {
    logError(error.message, {
      functionName: "getUserNotifications",
      service: "usernotification",
      statusCode: error.statusCode,
    });
    return { metadata: { total: 0 }, notifications: [] };
  }
};

export default getUserNotifications;
